module.exports = __webpack_public_path__ + "img/Unidad21-3.746d620f.png";